import { render, staticRenderFns } from "./PlannerNav.vue?vue&type=template&id=47d2885e&"
import script from "./PlannerNav.vue?vue&type=script&lang=js&"
export * from "./PlannerNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports